"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation updateBasicUserInfo ($firstName: String, $lastName: String, $imageUrl: String) {
    updateBasicUserInfo (firstName: $firstName, lastName: $lastName, imageUrl: $imageUrl) {
      _id
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=updateBasicUserInfo.mutation.js.map